module.exports = __webpack_public_path__ + "static/media/zh-CN.755bb2ad.md";